import { useHookstate } from "@hookstate/core";
import React, { useState } from "react";
import { Editor } from 'react-draft-wysiwyg';
import mock1 from "../../../assets/png/mock1.png";
import { useUniversalFindAll } from "../../../hooks/universal";
import { AddEventFormFields, ClubCategory, Department } from "../../../types";
import { ImageUploadWithPreview } from "../../ImageUploadWithPreview";
import InputField from "../../input-field/InputField";
import { DateInput } from "../EventCard";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import DatePicker from "react-datepicker";
import { CustomDateInput } from "../../CustomDateInput";
import "react-datepicker/dist/react-datepicker.css";
import { addEventFormFields } from "../../../misc/constants";
import { activitiesApi } from "../../../api/api";
import { simpleGetter } from "../../../actions/common";

type AddEventFormState = {
  form: AddEventFormFields
}

type AddEventCardProps = {
  onAddEvent: (e: any) => void;
  onClose: (e: any) => void;
}

export default function AddEventCard({ onAddEvent, onClose }: AddEventCardProps) {
  const departments: Department[] = useUniversalFindAll('Department')
  const categories: ClubCategory[] = useUniversalFindAll('ClubCategory')
  const [title, setTitle] = useState("");
  const [descr, setDescr] = useState("");
  const [isUrlChecked, setIsUrlChecked] = useState(false);
  const [url, setUrl] = useState("");
  const [status, setStatus] = useState("");
  const [img, setImg] = useState(mock1);

  const localState = useHookstate({
    form: new AddEventFormFields()
  } as AddEventFormState);
  const state = localState.get();
  const form = state.form;

  console.log(form)

  const updateForm = (key: keyof AddEventFormFields, value: any) => {
    localState.form[key].set(value);
  }

  const handleAddEvent = () => {
    if (title) {
      const newEvent = {
        id: Date.now(),
        title,
        descr,
        url: isUrlChecked ? url : null,
        status,
        img,
        actions: ["Опубликовать"],
      };
      onAddEvent(newEvent);
      resetForm();
    }
  };

  const resetForm = () => {
    setTitle("");
    setDescr("");
    setIsUrlChecked(false);
    setUrl("");
    setStatus("");
    setImg("");
  };

  const onFormInputChangeRaw = (key: keyof AddEventFormFields) => (value: any) => {
    updateForm(key, value);
  }

  const onFormInputChangeDate = (key: keyof AddEventFormFields) => (date: Date | null) => {
    updateForm(key, date);
  }


  const onFormInputChange = (key: keyof AddEventFormFields, type: string) => (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>) => {
    const target = e.target;

    switch (type) {
      case 'file':
        if (target instanceof HTMLInputElement && target.files?.length) {
          const reader = new FileReader();
          reader.onload = function (event) {
            // @ts-ignore
            localState.form[`${key}Base64`].set(event.target?.result)
            // @ts-ignore
            localState.form[key].set(target.files?.[0])
          }
          reader.readAsDataURL(target.files[0]);
        }
        break;
      case 'text':
      case 'select':
        updateForm(key, e.target.value);
        break;
      case 'checkbox':
        if (target instanceof HTMLInputElement) {
          updateForm(key, target.checked ? 1 : 0);
        }
    }
  }

  const onSubmit = async () => {
    const formData = new FormData();
    for (const f of addEventFormFields) {
      let value = form[f];

      if (typeof value === 'number') {
        value = String(value);
      } else if (value instanceof Date) {
        value = value.toISOString()
      }

      if (value instanceof File || typeof value === 'string') {
        formData.append(f, value);
      } else {
        console.warn(`Unsupported type for field "${f}":`, value);
      }
    }
    const response = await simpleGetter(activitiesApi.createActivity, formData);
  }

  return (
    <div className="relative text-black bg-white flex flex-col p-6 gap-6 w-full rounded-xl">
      <button
        className="absolute top-4 right-4 bg-red-500 text-white w-6 h-6 rounded-full flex items-center justify-center cursor-pointer"
        onClick={onClose}
      >
        ✕
      </button>

      <div className="flex flex-row gap-6">
        <ImageUploadWithPreview
          additionalClassName="flex-1"
          label="Обложка мероприятия"
          valueBase64={form.main_imageBase64}
          value={form.main_image}
          onChange={onFormInputChange('main_image', 'file')}
          placeholder="Загрузить обложку"
        />

        <div className="flex flex-col flex-1 gap-6">
          <InputField
            value={form.department_id}
            handleChange={onFormInputChange('department_id', 'select')}
            label="Департамент"
            id="department"
            placeholder=""
            type="select"
            options={departments.map(c => ({ value: c.id, label: c.title }))}
          />
          <InputField
            value={form.category_id}
            handleChange={onFormInputChange('category_id', 'select')}
            label="Категория"
            id="category"
            placeholder=""
            type="select"
            options={categories.map(c => ({ value: c.id, label: c.name }))}
          />
          <div className="flex flex-col">
            <p className="text-[#5F6B88] font-medium text-sm">Дата события</p>
            <DatePicker
              selected={form.start_date}
              onChange={onFormInputChangeDate('start_date')}
              customInput={<CustomDateInput />}
              dateFormat="dd/MM/yyyy HH:mm"
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Время"
            />
          </div>
        </div>
      </div>

      <InputField
        additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
        value={form.name}
        handleChange={onFormInputChange('name', 'text')}
        type="text"
        label="Заголовок события"
        id="activityName"
        placeholder="Введите заголовок"
      />

      <div className="flex flex-col">
        <p className="text-[#5F6B88] font-medium text-sm">Текст события</p>
        <ReactQuill
          className="bg-[#F0F3FA] w-full rounded-lg resize-none mt-2 min-h-[25vh] outline-none overflow-hidden"
          theme="snow"
          value={form.description}
          onChange={onFormInputChangeRaw('description')}
          modules={{
            toolbar: [
              [{ 'header': [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
              ['link', 'image'],
              ['clean']
            ]
          }}
        />
      </div>

      {/* <div>
        <p className="text-[#5F6B88] font-medium text-sm">Текст события</p>
        <textarea
          className="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg resize-none mt-2 h-[25vh] outline-none"
          placeholder="Введите текст описания"
          value={descr}
          onChange={(e) => setDescr(e.target.value)}
        />
        <p className="text-[#AFB7CA] text-xs font-medium ml-4">
          {descr.length}/800
        </p>
        <Editor />
      </div> */}

      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-lg"
        onClick={onSubmit}
      >
        Добавить событие
      </button>
    </div>
  );
}
